export default "__VITE_ASSET__DYuAdjIY__"